<template>
  <div class="separator">
    <slot name="default" />
  </div>
</template>

<script>
import VSeparatorMixin from '@/theme/default/components/widgets/VSeparator.js'

export default {
  name  : 'VSeparator',
  mixins: [VSeparatorMixin]
}
</script>

<style scoped src="@/theme/default/components/widgets/VSeparator.css"></style>

<style scoped>
</style>
